module.exports = "https://static.wanderu.com/ui-react/_next/static/media/magnifying-glass.d707bd8b.svg";